/*
 * FEDERAÇÃO DOS PROFISSIONAIS DA BELEZA
 * UTILITY: API BASE URL
 */

export const API_BASE: string =
  import.meta.env.VITE_API_URL ||
  (window as any).__ENV__?.API_URL ||
  'https://federacao.onrender.com/api/v1';

export const getToken = (): string =>
  localStorage.getItem('auth_token') ??
  localStorage.getItem('accessToken') ??
  '';

export const authH = (): HeadersInit => {
  const token = getToken();

  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};